import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import chevronLeft from "@iconify/icons-mdi/chevron-left";
import { InlineIcon } from "@iconify/react";
import { MyTimesheetMyRequestsDashboardDateRange } from "my-timesheet/components";
import { PeriodType } from "my-timesheet/types/period-type";

interface MyTimesheetPageTitleProps {
  title: string;
  currentDate?: Date;
  handleChangeCurrentDate?: (date: Date) => void;
  period?: "month" | "week";
  handlePeriodChange: (period: PeriodType) => void;
  showDateRange: boolean;
  goBack?: boolean;
  isMobile: boolean;
}

export const MyTimesheetPageTitle: React.FC<MyTimesheetPageTitleProps> = ({
  title,
  currentDate,
  handleChangeCurrentDate,
  period,
  handlePeriodChange,
  showDateRange,
  goBack,
  isMobile,
}) => {
  const theme = useTheme();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      justifyContent="space-between"
      alignItems={isMobile ? "flex-start" : "center"}
      padding="16px 0px"
    >
      <Box display="flex" alignItems="center">
        {goBack && (
          <Box>
            <InlineIcon
              id="go-back"
              icon={chevronLeft}
              width="32px"
              color={"#5E6366"}
              style={{
                cursor: "pointer",
                marginRight: "10px",
                marginTop: "5px",
              }}
              onClick={handleGoBack}
            />
          </Box>
        )}
        <Typography
          variant="h4"
          style={{
            color: theme.palette.gray80.main,
            marginLeft: isMobile && !goBack ? "16px" : "0px",
          }}
        >
          {title}
        </Typography>
      </Box>
      {isMobile && <Box height="16px" />}
      {showDateRange && (
        <Box width={isMobile ? "100%" : "auto"}>
          <MyTimesheetMyRequestsDashboardDateRange
            currentDate={currentDate ?? new Date()}
            onChangeCurrentDate={handleChangeCurrentDate ?? (() => {})}
            period={period ?? "month"}
            onPeriodChange={handlePeriodChange}
            isMobile={isMobile}
          />
        </Box>
      )}
    </Box>
  );
};

export default MyTimesheetPageTitle;
